import { useEditor } from '../store/editor'

export function Toasts() {
  const toasts = useEditor((s) => s.toasts)
  return (
    <div className="toasts" role="status" aria-live="polite">
      {toasts.map((t) => <div key={t.id} className={`toast ${t.kind}`}>{t.text}</div>)}
    </div>
  )
}

export function Busy() {
  const busy = useEditor((s) => s.busy)
  if (!busy) return null
  return (
    <div className="busy">
      <div className="card">
        <div className="spinner" />
        <div>{busy}</div>
      </div>
    </div>
  )
}
